var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOctagonXmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3755_22933)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8598 19.6407C21.8316 18.6126 20.1691 18.6126 19.152 19.6407C18.1348 20.6688 18.1238 22.3313 19.152 23.3485L24.2926 28.4892L19.152 33.6298C18.1238 34.6579 18.1238 36.3204 19.152 37.3376C20.1801 38.3548 21.8426 38.3657 22.8598 37.3376L28.0004 32.197L33.141 37.3376C34.1691 38.3657 35.8316 38.3657 36.8488 37.3376C37.866 36.3095 37.877 34.647 36.8488 33.6298L31.7082 28.4892L36.8488 23.3485C37.877 22.3204 37.877 20.6579 36.8488 19.6407C35.8207 18.6235 34.1582 18.6126 33.141 19.6407L28.0004 24.7813L22.8598 19.6407Z",
    fill: "#D84141"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.3779 2.8188C16.8545 1.34224 18.8561 0.510986 20.9451 0.510986H35.0545C37.1436 0.510986 39.1451 1.34224 40.6217 2.8188L53.6811 15.8782C55.1576 17.3547 55.9889 19.3563 55.9889 21.4454V35.5547C55.9889 37.6438 55.1576 39.6454 53.6811 41.1219L40.6217 54.1813C39.1451 55.6579 37.1436 56.4891 35.0545 56.4891H20.9451C18.8561 56.4891 16.8545 55.6579 15.3779 54.1813L2.31855 41.1219C0.841992 39.6454 0.0107422 37.6438 0.0107422 35.5547V21.4454C0.0107422 19.3563 0.841992 17.3547 2.31855 15.8782L15.3779 2.8188ZM19.1404 19.6407C18.1123 20.6688 18.1123 22.3313 19.1404 23.3485L24.2811 28.4891L19.1404 33.6297C18.1123 34.6579 18.1123 36.3204 19.1404 37.3376C20.1686 38.3547 21.8311 38.3657 22.8482 37.3376L27.9889 32.1969L33.1295 37.3376C34.1576 38.3657 35.8201 38.3657 36.8373 37.3376C37.8545 36.3094 37.8654 34.6469 36.8373 33.6297L31.6967 28.4891L36.8373 23.3485C37.8654 22.3204 37.8654 20.6579 36.8373 19.6407C35.8092 18.6235 34.1467 18.6125 33.1295 19.6407L27.9889 24.7813L22.8482 19.6407C21.8201 18.6125 20.1576 18.6125 19.1404 19.6407Z",
    fill: "#F2A9BC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3755_22933"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOctagonXmark);
export default __webpack_public_path__ + "static/media/octagon-xmark.ba7250cd0d82409eb27b86c866f6159f.svg";
export { ForwardRef as ReactComponent };